import React, { useEffect, useState } from 'react';
import createConnection from '../../services/signalRConnection';
import AlertSnackbar from './AlertSnackbar';
import { useSelector } from 'react-redux';

const SignalRListener = ({ backend = 'server' }) => {
  const token = useSelector(state => state.auth.login?.dataUser?.tokenGenerated);
  const [connection, setConnection] = useState(null);
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    if (!token) return;

    const newConnection = createConnection(token, backend);
    setConnection(newConnection);

    newConnection
      .start()
      .then(() => {
        newConnection.on("ReceiveAlert", (message) => {
          setAlerts(prev => [...prev, message]);
        });
      })
      .catch(err => console.error(`[SignalR][${backend}] ❌ Error al conectar:`, err));

    return () => {
      newConnection.stop();
    };
  }, [token, backend]);

  const handleClose = (index) => {
    setAlerts(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      {alerts.map((msg, index) => (
        <AlertSnackbar
          key={index}
          message={msg}
          onClose={() => handleClose(index)}
          offset={index}
        />
      ))}
    </>
  );
};

export default SignalRListener;
